import React from "react";
import { Action } from "../../../constants/Common";
import CreatorDetails from "./creatorDetails";
import { ActivityModule } from "../../../constants/Module";
import { withTranslation } from "react-i18next";

const AddResource = ({ item, t }) => {

    return (
        <React.Fragment>
            <div className="mx-2">
                {item?.module === ActivityModule.CHANGE_REQUEST_ITEM &&
                    <div>
                        <strong> {t('Add Resource')} ({item?.payload?.payload?.name} | {item?.payload?.payload?.uniqueUserId}) </strong>
                         {item?.event === Action.CREATE ? t('was added to') : t('was removed from')} <strong>{t('change request')} ({item?.payload?.changeRequest?.uniqueChangeRequestId})</strong>
                        <CreatorDetails creator={item?.creator} date={item?.createdAt} />
                    </div>
                }
                {item?.module === ActivityModule.PROJECT_USER &&
                    <div>
                        <strong> {t('Resource')} ({item?.payload?.user?.name} | {item?.payload?.user?.uniqueUserId}) </strong>
                        {t('was added from')} <strong>{t('change request')} ({item?.payload?.changeRequest?.uniqueChangeRequestId})</strong> {t('to')} <strong>{t('startup')} ({item?.payload?.project?.uniqueProjectId})</strong>
                        <CreatorDetails creator={item?.creator} date={item?.createdAt} />
                    </div>
                }
            </div>
        </React.Fragment>
    )
}
export default withTranslation()(AddResource);
